import levelsData from "../../levels.json";

export interface LevelProgress {
  level: number;
  expNeeded: number;
  currentLevelExp: number;
}

export interface UserProgressFields {
  level: number;
  exp_current: number;
  exp_to_levelup: number;
  currency_balance?: number | null;
  level_cap?: number | null;
}

export interface UserProgressDelta {
  expDelta?: number;
  pearlDelta?: number;
}

export const calculateTotalExp = (level: number, currentLevelExp: number): number => {
  const levelInfo = levelsData.find(l => l.lvl === level);
  if (levelInfo) {
    return levelInfo.start_exp + currentLevelExp;
  }
  return currentLevelExp;
};

export const calculateLevelFromExp = (totalExp: number): LevelProgress => {
  let currentLevel = 1;
  let currentLevelExp = totalExp;
  let expNeeded = levelsData[0].exp_needed;

  for (let i = levelsData.length - 1; i >= 0; i--) {
    const levelInfo = levelsData[i];
    if (totalExp >= levelInfo.start_exp) {
      currentLevel = levelInfo.lvl;
      currentLevelExp = totalExp - levelInfo.start_exp;
      expNeeded = levelInfo.exp_needed;
      break;
    }
  }

  return { level: currentLevel, expNeeded, currentLevelExp };
};

export const getCurrentLevelExp = (totalExp: number): number => {
  for (let i = levelsData.length - 1; i >= 0; i--) {
    const levelInfo = levelsData[i];
    if (totalExp >= levelInfo.start_exp) {
      return totalExp - levelInfo.start_exp;
    }
  }
  return totalExp;
};

export const applyUserProgressDelta = <T extends UserProgressFields>(
  user: T,
  { expDelta, pearlDelta }: UserProgressDelta,
): T => {
  const result = { ...user };

  if (pearlDelta !== undefined) {
    const nextPearls = (user.currency_balance || 0) + pearlDelta;
    result.currency_balance = pearlDelta < 0 ? Math.max(0, nextPearls) : nextPearls;
  }

  if (expDelta !== undefined) {
    const currentTotalExp = calculateTotalExp(user.level, user.exp_current);
    let newTotalExp = currentTotalExp + expDelta;

    if (expDelta < 0) {
      newTotalExp = Math.max(0, newTotalExp);
    } else if (user.level_cap) {
      const gateLevelInfo = levelsData.find(l => l.lvl === user.level_cap);
      if (gateLevelInfo) {
        newTotalExp = Math.min(newTotalExp, gateLevelInfo.start_exp - 1);
      }
    }

    const levelInfo = calculateLevelFromExp(newTotalExp);
    const newExpCurrent = getCurrentLevelExp(newTotalExp);

    result.level = levelInfo.level;
    result.exp_current = newExpCurrent;
    result.exp_to_levelup = levelInfo.expNeeded;
  }

  return result;
};
